import { Control, Controller } from "react-hook-form";
import { InputProps } from "../../Inputs/Inputs";
import { ChangeEvent } from "react";
import { InputSelect } from "../../Inputs/InputSelect";
import { SelectOption } from "../../../../common/types/selectOption";

interface ControlSelectProps extends InputProps {
  control: Control<any>;
  defaultValue?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  options: SelectOption[] | undefined;
}

export const ControlSelect = ({
  control,
  defaultValue,
  label,
  size,
  width,
  direction,
  name,
  placeholder,
  options,
  onChange,
}: ControlSelectProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState }) => (
        <InputSelect
          name={name}
          direction={direction}
          size={size}
          width={width}
          label={label}
          placeholder={placeholder}
          errored={!!formState.errors[name]}
          erroredTxt={formState.errors[name]?.message}
          options={options}
          onChange={onChange ? onChange : field.onChange}
          value={field.value}
        />
      )}
    />
  );
};
